module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctl",
    attrs: {
      "id": "d12e384"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wals_ISBN1418537640_epub_c4_r1#d12e127",
      "id": "d12e385"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "h2l",
    attrs: {
      "id": "d12e387"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wals_ISBN1418537640_epub_c4_r1#d12e127",
      "id": "d12e388"
    }
  }, [_vm._v("What Does the Bible "), _c('br'), _vm._v("Actually Say about Prayer?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "d12e392"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wals_ISBN1418537640_epub_c4_r1#d12e130",
      "id": "d12e393"
    }
  }, [_c('i', [_vm._v("Which of My Ideas Are from the Bible "), _c('br'), _vm._v("and Which Are from the “Church Lady”?")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d12e398"
    }
  }, [_vm._v("To be a Christian without prayer is no more possible than "), _c('br'), _vm._v("to be alive without breathing. —MARTIN LUTHER")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d12e402"
    }
  }, [_vm._v("Be joyful always; pray continually; give thanks in all circumstances, "), _c('br'), _vm._v("for this is God’s will for you in Christ Jesus. —1 THESSALONIANS 5:16–18")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e406"
    }
  }, [_vm._v("My ten-year-old son, Christian, is very computer literate, as are most fifth graders these days. Last Thanksgiving he saw me staring at a large, frozen turkey on the kitchen counter. Immediately assessing I had cooking issues, he said, “Just Google it, Mom.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e408"
    }
  }, [_vm._v("“I beg your pardon?” I replied, eyeing the forbidding frosty fowl. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e410"
    }
  }, [_vm._v("“If you’re not sure what to do, just Google it,” he said. “That always works for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e412"
    }
  }, [_vm._v("So Google it I did, and I found the cooking instructions I needed. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e414"
    }
  }, [_vm._v("Now, I realize I may have lost you already. If you are not computer savvy, I empathize. I still find it hard to believe I can pick up a piece of plastic—commonly called a telephone—punch in a few numbers, and in seconds be talking to my mother on the west coast of Scotland. But it doesn’t stop there. Life marches on at an unbridled pace these days. Now I can go online with my laptop, use a search engine like Google, punch in “Help me! My turkey is still frozen!” and within moments receive the message, “You should have taken it out last night, you moron!” (No, not actually. What I did receive was a very detailed plan for thawing and cooking an award-winning roast beast.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e416"
    }
  }, [_vm._v("Google and other online search engines have not only brought the world to our doorstep, but they have also taken us to the world. Before I left for Nairobi, Kenya, in December 2006, I set up Google Earth on my laptop for Christian. Each evening he could log on and, with the punch of a few keys, locate a live shot of our house in Frisco, Texas. Then he could type in my location in Africa, and the satellite would pull out as the globe on the screen spun to Africa and focused on where I was that day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e419"
    }
  }, [_vm._v("Wow! The world is getting smaller every day. In many ways that’s a good thing, but in other ways not so much. Take prayer, for example. Since nowadays just about anyone can reach out and touch us, we’re being bombarded from all directions with a hodge-podge of ideas on how to relate to God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e421"
    }
  }, [_vm._v("Out of curiosity, I decided to Google the word "), _c('i', [_vm._v("prayer")]), _vm._v(". I couldn’t believe the response—a smorgasbord offered in the name of communion with almighty God. One website detailed a free mini course that would teach me about the “seven spirits of God.” Another site offered telephone miracles twenty-four hours a day that would enhance my health, my finances, and my relationships. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e426"
    }
  }, [_vm._v("One interesting site even showed me pictures of what prayer should look like. It said if I was a Christian, I should bow my head and clasp my hands together. If I was a Native American, I should dance; if a Hindu, chant; if a Sufi, whirl. If I was an Orthodox Jew, I should sway, and if I was a Quaker . . . I should be quiet!")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e428"
    }
  }, [_vm._v("THE WISDOM OF THE YOUNG")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e430"
    }
  }, [_vm._v("Googling "), _c('i', [_vm._v("prayer ")]), _vm._v("proved to be more confusing than helpful, so I asked some of my son’s friends this simple question: “What does the Bible say about prayer?” Their responses were interesting, to say the least. Here are a few:")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e435"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0020_004",
      "id": "d12e436",
      "src": "images/0849919533_ePDF_0020_004.jpg"
    }
  }), _vm._v(" “Don’t even try it if you’re mad with your dad—God won’t be listening.”")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e438"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0020_004",
      "id": "d12e439",
      "src": "images/0849919533_ePDF_0020_004.jpg"
    }
  }), _vm._v(" “Wash your hands first!”")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e441"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0020_004",
      "id": "d12e442",
      "src": "images/0849919533_ePDF_0020_004.jpg"
    }
  }), _vm._v(" “Remember to say amen or everyone’s food will get cold!”")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e444"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0020_010",
      "id": "d12e445",
      "src": "images/0849919533_ePDF_0020_010.jpg"
    }
  }), _vm._v(" “Think about others before you think about yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e447"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0020_012",
      "id": "d12e448",
      "src": "images/0849919533_ePDF_0020_012.jpg"
    }
  }), _vm._v(" “Just concentrate on God and try not to fall asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e450"
    }
  }, [_c('i', [_vm._v("Hmm. ")]), _vm._v("Not quite what I’d been looking for. Their answers conveyed that there are right things to do and wrong things to do when we pray—and you’d better get it right if you even have a hope of God listening to you! Their responses also seemed to indicate that they had been corrected in their past efforts at prayer and were working with a fresh set of ground rules.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e455"
    }
  }, [_vm._v("But something besides their responses jumped out at me. Interestingly, the boys’ tone of voice changed when I asked them about prayer. Even my own animated son became a Francis of Assisi as he responded—quiet, gentle, reverent. (I have to tell you, however, that moment soon passed.) This indicated to me that even at a young age, we’re conditioned to believe that fellowship with God is some sort of lofty and theological transaction. The boys’ attitude mirrored what they had seen others do in an attempt to be “religious.” They had no clue how to answer the question accurately, but they sure did put on a good show while they were talking about it!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e457"
    }
  }, [_vm._v("When I thought about it, I had to confess I’ve sometimes done the same. And I’m sure you have too. Think about it—how many times have we been asked to pray in public and, instead of talking with God using the manner and words we offer at home, we find our “spiritual” voices, religious vocabulary, and pious pose?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e459"
    }
  }, [_vm._v("Surely that can’t be how God wants us to relate to him. So what does the Bible actually tell us about prayer? It seemed a good time to go to the source and investigate.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e461"
    }
  }, [_vm._v("WHAT DOES THE BIBLE "), _c('br'), _vm._v("TELL US ABOUT PRAYER?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e465"
    }
  }, [_vm._v("As I pored over the Scriptures, searching for what God has to say about prayer, several things became immediately clear:")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e467"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0022_002",
      "id": "d12e468",
      "src": "images/0849919533_ePDF_0022_002.jpg"
    }
  }), _vm._v(" We are called to pray with a "), _c('i', [_vm._v("clean heart ")]), _vm._v(": “If I regard iniquity in my heart, the Lord will not hear. But certainly God has heard me; He has attended to the voice of my prayer” (Psalm 66:18–19 NKJV).")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e473"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0022_002",
      "id": "d12e474",
      "src": "images/0849919533_ePDF_0022_002.jpg"
    }
  }), _vm._v(" We are called to pray, "), _c('i', [_vm._v("believing ")]), _vm._v(": “And whatever things you ask in prayer, believing, you will receive” (Matthew 21:22 NKJV).")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e479"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0022_002",
      "id": "d12e480",
      "src": "images/0849919533_ePDF_0022_002.jpg"
    }
  }), _vm._v(" We are called to pray "), _c('i', [_vm._v("in Christ’s name")]), _vm._v(": “And whatever you ask in My name, that I will do, that the Father may be glorified in the Son” (John 14:13 NKJV).")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e485"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0022_002",
      "id": "d12e486",
      "src": "images/0849919533_ePDF_0022_002.jpg"
    }
  }), _vm._v(" We are called to pray according to "), _c('i', [_vm._v("the Father’s will")]), _vm._v(": “Now this is the confidence that we have in Him, that if we ask anything according to His will, He hears us” (1 John 5:14 NKJV).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e491"
    }
  }, [_vm._v("On second thought, even with these “clear” instructions, I still had questions. So I took a closer look at these four directives.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e493"
    }
  }, [_vm._v("A Clean Heart")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e496"
    }
  }, [_vm._v("According to Psalm 66:18, our purity of heart is so essential that if we “regard iniquity in [our] heart, the Lord will not hear” (NKJV). And in Psalm 51:10, David urges God to give him “a clean heart” (NKJV).")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e498"
    }
  }, [_vm._v("What exactly is a “clean heart”? How clean, exactly? Scrubbed-spotless- till-you-can-see-your-reflection clean? Or quick-tidy-up-before-the-guests-arrive clean?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e500"
    }
  }, [_vm._v("As women, our hormones lead us on a lively dance for most of our lives. So what do we do on those “days of the month” when we don’t feel very holy or sometimes even sane? Does God hear our prayers when our emotions are taking us on a roller coaster ride? What if we want to have a clean heart, but we’re having trouble with it? What if we "), _c('i', [_vm._v("believe ")]), _vm._v("we have a clean heart, but there is some little seed of unforgiveness buried deep inside us we’ve forgotten all about? Are we only responsible for the sins we remember or for every little offense we’ve committed over our entire lifetime?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e505"
    }
  }, [_vm._v("I received a letter from a woman who had been sexually abused by her father when she was a child. Her concern was that there were months of this devastating time in her childhood she had blocked out. She simply couldn’t remember what had happened. “How can I come to God with a clean heart when I can’t remember so much of that horrible time? Will God hold that against me?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e507"
    }
  }, [_vm._v("My heart ached for this woman who had already suffered so much and was now tormented by the thought that the offenses acted out upon her would hinder her prayers and follow her for the rest of her life. I wanted to tell her that part of the miracle of prayer is that God knows what we need before we even ask him. When it is our earnest desire to be clean, he sees that—whether we can remember every detail of our lives or not. Yes, he wants us to come before him with a pure heart, but he also tells us that he hears our honest petitions. Notice what verse 19 of Psalm 66 says: “Certainly God has heard me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e509"
    }
  }, [_vm._v("We can’t keep worrying about how clean the corners of our soul are. If we get caught up in that whirlpool of self-loathing and doubt, we’re only headed down. But if we come before the God who makes all things new, believing in faith that he knows our true hearts, we are certain to be uplifted.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e511"
    }
  }, [_vm._v("Believing")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e513"
    }
  }, [_vm._v("Surely Jesus’ words recorded in Matthew 21:22 have caused much confusion among believers: “And whatever things you ask in prayer, believing, you will receive.” “Whatever” covers a lot of ground.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e515"
    }
  }, [_vm._v("Perhaps you have been exposed to prosperity teaching, which seems to advocate “if you can name it, you can claim it; if you can mark it, you can park it!” This theology is not an accurate understanding of what the Bible teaches. Prosperity teaching takes the wonderful truth that our Father is the King of kings and reduces it to the conclusion that we should all then live like royalty on this earth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e517"
    }
  }, [_vm._v("For instance, I was channel surfing one night and landed on a religious talk show. Three college students were being interviewed about their faith. One girl held up a picture of a red Mercedes convertible and announced proudly that this was what she was “believing” for. As though that’s what Jesus had in mind for her!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e519"
    }
  }, [_vm._v("But beyond the self-indulgent misinterpretations of this verse is a much more serious heart cry from those who long for God to intervene when life is falling apart and who can’t understand why he doesn’t appear to hear their prayers. From 1987 to 1992, I was cohost of "), _c('i', [_vm._v("The 700 Club ")]), _vm._v("with Dr. Pat Robertson. I received hundreds of letters from viewers who stumbled over this misunderstanding of prayer. They said things like:")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e525"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0024_008",
      "id": "d12e526",
      "src": "images/0849919533_ePDF_0024_008.jpg"
    }
  }), _vm._v(" “I prayed in faith that my husband would be healed of cancer, but he died. What did I do wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e528"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0024_008",
      "id": "d12e529",
      "src": "images/0849919533_ePDF_0024_008.jpg"
    }
  }), _vm._v(" “I have given and given to the church and this ministry believing for a miracle in my own finances, but I am still in debt. What am I doing wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "ul2",
    attrs: {
      "id": "d12e531"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0849919533_ePDF_0024_008",
      "id": "d12e532",
      "src": "images/0849919533_ePDF_0024_008.jpg"
    }
  }), _vm._v(" “I have kept myself pure and prayed, believing that God would bring me a husband, and I am still alone. Why isn’t God honoring my prayers?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e534"
    }
  }, [_vm._v("I witnessed such torment in people’s lives. Many felt they were doing something wrong, and if they could just find out what the key was, things would been different. Can you imagine the agony of believing your child or your husband would not have died if you had somehow worked out this puzzle in time? Or the pain of the woman who sits home alone wondering where her soul mate is as she watches the years pass by, taking with them her ability to be a mother?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e536"
    }
  }, [_vm._v("To these situations, add the agony of silence. If you believe that somehow whatever reality you are living in is your fault, who do you dare talk to? How can you voice these things aloud and risk seeing disapproval in the eyes of someone else?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e538"
    }
  }, [_vm._v("I think this verse has left many sitting alone and lost. I’ll be honest: there’s no easy answer. But I think that part of the problem is we tend to focus on only one part of that scripture. We want to hear all about the “receiving” side of things—"), _c('i', [_vm._v("What are you going to ")]), _c('i', [_vm._v("do for me, God? Why haven’t you given me what I asked for?—")]), _vm._v("rather than the “believing” side—"), _c('i', [_vm._v("God, I believe in you 100 percent and ")]), _c('i', [_vm._v("know you love me, and today that’s all that matters. ")]), _vm._v("God has and always will have our best interests at heart. Just as our children look at us in faith, knowing we love them and will take care of them, we need to do the same with our heavenly Father. I’m not saying that will always be easy; we might want to stomp our foot or cry into our pillows. But we have to trust that God will make all things clear some day.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e550"
    }
  }, [_vm._v("In Jesus’ Name")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e552"
    }
  }, [_vm._v("In John’s gospel we read that whatever prayers we ask "), _c('i', [_vm._v("in Jesus’ name ")]), _vm._v("will be answered so that God the Father will be glorified (14:13). This is such an incredible gift. But . . . the authority we’re given can be a dangerous thing. I think it’s easy to tag, “In Jesus’ name, amen” to the end of our prayers without thinking through the full implications of what that means.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e557"
    }
  }, [_vm._v("Coming in someone’s name means you represent that person —you have been granted the authority to speak for them. For example, when police officers or FBI agents present themselves at someone’s home, they produce identification to show that they have the authority of the agency they represent behind them. Likewise, when we say, “In Jesus’ name,” we are saying we are on royal business. Understanding that has helped me be bold in prayer but also be careful that my requests are in keeping with the character of Christ. I have a fresh sense of what an honor it is to be able to come to God in his Son’s name, and I work hard to not abuse the privilege.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e559"
    }
  }, [_vm._v("According to the Father’s Will")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e561"
    }
  }, [_vm._v("In John’s first letter, he clarifies that we are to ask according to the "), _c('i', [_vm._v("Father’s will, ")]), _vm._v("and he will hear us (5:14). What exactly does that mean? How do we keep from replacing his wishes with our own? Even more, how do we even know what the Father’s will is in any given situation? To my human understanding, it would always seem to be God’s will to heal a child or a broken marriage. Wouldn’t such a miracle bring glory to God? What about when a child prays a simple prayer of faith in Jesus’ name? Surely God would answer that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e567"
    }
  }, [_vm._v("My son faced this heartbreaking dilemma when he was just four years old. My father-in-law, William Pfaehler, lived with us for two years after the death of his wife, Eleanor. Having him in our home was a wonderful gift to all of us, but especially to Christian. He loved his papa so much, and they had a lot of fun together. One night when my husband, Barry, was in Florida, William had a heart attack and collapsed in his bathroom. Christian and I sat with him until the paramedics arrived. He was still breathing when they loaded him into the ambulance, but his lips were very blue. Christian and I followed the ambulance to the hospital. When we arrived, the doctor informed us that William had not survived the trip.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e569"
    }
  }, [_vm._v("Christian was quiet as we drove home. All he said that night was, “I’m going to miss my papa.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e571"
    }
  }, [_vm._v("He grieved openly for weeks, and then one day I saw a flash of anger cross his face as he brushed our cat, Lily, off the sofa. I suggested that we take a walk, and I asked him if he was angry. With his customary honesty, he told me he was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e573"
    }
  }, [_vm._v("“You told me, Mom, that Jesus listens to our prayers and answers them. Well, I asked God not to take my papa, and he did anyway. So what’s the point?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e575"
    }
  }, [_vm._v("I felt my son’s pain. (Is there a believer alive who hasn’t thought that when it seemed as if heaven was silent to his or her cries?) At his tender age, my son had to experience what it means to pray according to the Father’s will, whether or not he—or I—understood it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e577"
    }
  }, [_vm._v("There is obviously much more to this thing called "), _c('i', [_vm._v("prayer ")]), _vm._v("than what we currently know. Though you and I will be gathering information about prayer all our days, our lives are only a speck of time in God’s plan. There’s no way we could hope to understand everything in our limited time on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e582"
    }
  }, [_vm._v("Of course, that doesn’t stop us from trying to figure it out, does it? Sometimes we’re tempted to think we know all the answers—or at least most of them. We draw conclusions from our limited perceptions and try to force ourselves and others into believing them. ")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e584"
    }
  }, [_vm._v("THE CHURCH LADY")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e586"
    }
  }, [_vm._v("If you were a fan of the television show "), _c('i', [_vm._v("Saturday Night Live ")]), _vm._v("in the late eighties"), _c('i', [_vm._v(", ")]), _vm._v("you might remember a character created by Dana Carvey. Her name was Enid Strict, affectionately referred to as the Church Lady. She was the very prim, proper, and pious host of a talk show called "), _c('i', [_vm._v("Church Chat")]), _vm._v(". As she interviewed celebrities, the Church Lady used her platform to rail against their ungodly behavior.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e597"
    }
  }, [_vm._v("Carvey says he based the character on women from the church he attended while he was growing up who would keep track of his and others’ attendance."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Wals_ISBN1418537640_epub_c29_r1#d12e4460",
      "id": "d12e599",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" I find that very sad. I wonder how many people have encountered a Church Lady growing up, and because of her strict views, they think God judges them according to their church attendance. That he answers their prayers based upon their adherence to rules defined by culture more than by Scripture. I can’t imagine many people would want to pour out their heart to someone like that. In the hands of someone like Enid Strict, prayer is a weapon to be used against people: “Sic ’em, God!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e603"
    }
  }, [_vm._v("Prayer is not always easy. Nor is it always joyful. And no, we don’t always get what we hope for out of the dialogue. What I do firmly reject, however, is the idea that God is a cruel puzzle maker who watches dispassionately to see if we will figure things out in time. That goes against the whole story revealed through the Word of God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e606"
    }
  }, [_vm._v("From the first words of Genesis until the glorious conclusion at the end of the Revelation to John, what flows from every page of Scripture is one grand prayer adventure. It is a love story about a God who chooses relationship rather than blind obedience, who allowed his only Son to be tortured and killed so that you and I could be washed clean of the sin that separates us from him. God does not torture his beloved people. He calls to them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e608"
    }
  }, [_vm._v("Perhaps in this first chapter I have found more questions than answers, but I am convinced of one thing—it matters that we pray. After all, Jesus didn’t say "), _c('i', [_vm._v("if ")]), _vm._v("you pray but "), _c('i', [_vm._v("when ")]), _vm._v("you pray (Matthew 6:5).")]), _vm._v(" "), _c('p', {
    staticClass: "ext5",
    attrs: {
      "id": "d12e616"
    }
  }, [_c('i', [_vm._v("What a Friend we have in Jesus, "), _c('br'), _vm._v("all our sins and griefs to bear! "), _c('br'), _vm._v("What a privilege to carry "), _c('br'), _vm._v("everything to God in prayer! "), _c('br'), _vm._v("O what peace we often forfeit, "), _c('br'), _vm._v("O what needless pain we bear, "), _c('br'), _vm._v("All because we do not carry "), _c('br'), _vm._v("everything to God in prayer.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext5",
    attrs: {
      "id": "d12e634"
    }
  }, [_c('i', [_vm._v("Have we trials and temptations? "), _c('br'), _vm._v("Is there trouble anywhere? "), _c('br'), _vm._v("We should never be discouraged; "), _c('br'), _vm._v("take it to the Lord in prayer. "), _c('br'), _vm._v("Can we find a friend so faithful "), _c('br'), _vm._v("who will all our sorrows share? "), _c('br'), _vm._v("Jesus knows our every weakness; "), _c('br'), _vm._v("take it to the Lord in prayer.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext5",
    attrs: {
      "id": "d12e652"
    }
  }, [_c('i', [_vm._v("Are we weak and heavy laden, "), _c('br'), _vm._v("cumbered with a load of care? "), _c('br'), _vm._v("Precious Savior, still our refuge, "), _c('br'), _vm._v("take it to the Lord in prayer. "), _c('br'), _vm._v("Do your friends despise, forsake you? "), _c('br'), _vm._v("Take it to the Lord in prayer! "), _c('br'), _vm._v("In His arms He’ll take and shield you; "), _c('br'), _vm._v("you will find a solace there.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext5",
    attrs: {
      "id": "d12e670"
    }
  }, [_c('i', [_vm._v("Blessed Savior, Thou hast promised "), _c('br'), _vm._v("Thou wilt all our burdens bear "), _c('br'), _vm._v("May we ever, Lord, be bringing all to "), _c('br'), _vm._v("Thee in earnest prayer. "), _c('br'), _vm._v("Soon in glory bright unclouded there "), _c('br'), _vm._v("will be no need for prayer "), _c('br'), _vm._v("Rapture, praise and endless worship will be "), _c('br'), _vm._v("our sweet portion there.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext5",
    attrs: {
      "id": "d12e688"
    }
  }, [_vm._v("—JOSEPH M. SCRIVEN")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8040aa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wals_ISBN1418537640_epub_c8_r1.vue
// module id = 78
// module chunks = 0